import { Injectable } from '@angular/core';
import { FormGroup, UntypedFormControl, UntypedFormGroup } from '@angular/forms';

@Injectable()
export class FormHelper {
    public getFilledRequiredControlsCount(controls: object): number {
        const filled = [];
        for (const name of Object.keys(controls)) {
            const control = controls[name];
            const {validator} = control;
            if (validator) {
                const validation = validator(new UntypedFormControl());
                if (controls[name].value && controls[name].value !== '' && validation !== null && validation.required === true) {
                    filled.push(name);
                }
            }
        }

        return filled.length;
    }

    public getRequiredControlsCount(controls: object): number {
        const required = [];
        for (const name of Object.keys(controls)) {
            const control = controls[name];
            const {validator} = control;
            if (validator) {
                const validation = validator(new UntypedFormControl());
                if (validation !== null && validation.required === true) {
                    required.push(control);
                }
            }
        }

        return required.length;
    }

    // in formControl[`label`] we have translated label
    public getFormErrors(form: UntypedFormGroup): string[] {
        const returnArr = [];
        const controls = form.controls;

        for (const controlName of Object.keys(controls)) {
            const formControl = controls[controlName];

            // custom field group
            if (formControl instanceof FormGroup) {
                for (const subControlName of Object.keys(formControl.controls)) {
                    const subFormControl = formControl.controls[subControlName];
                    if (subFormControl.status === 'INVALID' && subFormControl.errors.required) {
                        returnArr.push(subFormControl[`label`]);
                    }
                }
                // normal control
            } else {
                if (formControl.status === 'INVALID' && formControl.errors.required) {
                    returnArr.push(formControl[`label`]);
                }
            }
        }

        return returnArr;
    }
}
